import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Stack } from '@mui/material';
import GoogleImg from 'imageAssets/google-store.svg';
import AppleImg from 'imageAssets/apple-store.svg';
import Mobile from 'imageAssets/mobile.svg';
import { MobileLogo, RequestDownloadContainer } from './forms/styled.forms';
import { useHistory } from 'react-router-dom';

const MobileScreen = () => {
  const fromApp = localStorage.getItem('from_app');
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const history = useHistory();

  const continueWithWeb = () => {
    sessionStorage.setItem('chooseWeb', 'yes');
    history.push('/dashboard');
  };
  useEffect(() => {
    if (fromApp) {
      setIsAppInstalled(true);
    } else {
      setIsAppInstalled(false);
    }
  }, [fromApp]);

  const handleClearStorage = () => {
    localStorage.removeItem('from_app');
    localStorage.removeItem('access_token');
  };

  return (
    <>
      <Helmet>
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      </Helmet>
      <Box
        sx={{
          background: `rgba(188, 186, 186, 0.19)`,
          height: '100vh',
          display: 'grid'
        }}
        style={{ backdropFilter: 'blur(2px)', placeItems: 'center' }}
      >
        <RequestDownloadContainer
        // className={classes.container}
        // sx={{
        //   display: 'flex',
        //   flexDirection: 'column',
        //   borderRadius: '27px',
        //   bgcolor: '#ffffff',
        //   zIndex: 5,
        //   width: '80%'
        // }}
        >
          <MobileLogo
            src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638786088/Bizedge_Frontend_Assets/Bizedge_logo_axcwlg.svg'
            alt='logo'
            width={100}
            height={50}
            className=''
          />
          {isAppInstalled ? (
            <>
              {/* <Typography sx={{ display: { xs: 'none', lg: 'bock' } }}>
                You are all set
              </Typography> */}
              <Typography className='sub-text'>
                You're currently viewing this Web App on your mobile device.
                Download our BizEdge Mobile App for a better experience.
              </Typography>
              {/* <Link
                to={{ pathname: os === 'iOS' ? appleUrl : androidUrl }}
                target='_blank'
                onClick={handleClearStorage}
              >
                <Button
                  variant='contained'
                  color='secondary'
                  fullWidth={true}
                  disableElevation={true}
                  onClick={handleClearStorage}
                >
                  Open in app
                </Button>
              </Link> */}
              <Stack
                direction={'row'}
                justifyContent={'space-around'}
                textAlign={'center'}
                justifyItems={'center'}
                // gap={1}
                mt={3}
                alignItems={'center'}
              >
                <a
                  href='https://apps.apple.com/us/app/bizedge/id1595146577'
                  target='_blank'
                  onClick={handleClearStorage}
                  rel='noreferrer'
                >
                  {' '}
                  <img src={AppleImg} alt='apple store' className='stores' />
                </a>
                <a
                  href='https://play.google.com/store/apps/details?id=com.bizedge&pli=1'
                  target='_blank'
                  onClick={handleClearStorage}
                  rel='noreferrer'
                >
                  {' '}
                  <img
                    src={GoogleImg}
                    alt='google play store'
                    className='stores'
                  />
                </a>
              </Stack>
            </>
          ) : (
            <>
              {/* <Typography
                
                sx={{ display: { xs: 'none', lg: 'bock' } }}
              >
                You are all set
              </Typography> */}
              <Typography className='sub-text'>
                You're currently viewing this Web App on your mobile device.
                Download our BizEdge Mobile App for a better experience.
              </Typography>
              <Box>
                {/* <Link
                  to={{
                    pathname:
                      os === 'iOS'
                        ? 'https://apps.apple.com/us/app/bizedge/id1595146577'
                        : 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.bizedge'
                  }}
                  target='_blank'
                  onClick={handleClearStorage}
                >
                  <Button
                    variant='contained'
                    color='secondary'
                    fullWidth={true}
                    disableElevation={true}
                  >
                    Download mobile app
                  </Button>
                </Link> */}
                <Stack
                  direction={'row'}
                  justifyContent={'space-around'}
                  mt={3}
                  alignItems={'center'}
                >
                  <a
                    href='https://apps.apple.com/us/app/bizedge/id1595146577'
                    target='_blank'
                    onClick={handleClearStorage}
                    rel='noreferrer'
                  >
                    {' '}
                    <img src={AppleImg} alt='apple store' className='stores' />
                  </a>
                  <a
                    href='https://play.google.com/store/apps/details?id=com.bizedge&pli=1'
                    target='_blank'
                    onClick={handleClearStorage}
                    rel='noreferrer'
                  >
                    {' '}
                    <img
                      src={GoogleImg}
                      alt='google play store'
                      className='stores'
                    />
                  </a>
                </Stack>
              </Box>
              <img
                src={Mobile}
                alt='Mobile app preview'
                style={{ width: '80%' }}
              />
              <Button
                variant='outlined'
                className='redirect-button'
                // onClick={() => history.push('/dashboard')}
                onClick={() => continueWithWeb()}
              >
                No, Continue to BizEdge Web
              </Button>
            </>
          )}
        </RequestDownloadContainer>
      </Box>
    </>
  );
};

export default MobileScreen;
